import { useState } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Calendar } from '@mint-lib/icons';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerPortal,
  DrawerRoot,
  DrawerTitle,
  DrawerTrigger,
} from '@mint-lib/tw-components';

import { usePreviewActivityListApi } from '../../../../../../api/queries/usePreviewActivityListApi.js';
import { useChosenVersionId } from '../../../../../../hooks/useChosenVersionId.js';
import FlightsDrawerContent from '../FlightsDrawer/FlightsDrawerContent.jsx';

const ManageFlightsBtn = () => {
  const { t } = useTranslation('@myn/planning_v2');

  const { data: activityList } = usePreviewActivityListApi();

  const chosenVersionId = useChosenVersionId();

  const isActivityListEmpty = !activityList?.items.length;

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Drawer open={open}>
      <DrawerTrigger asChild>
        <Button
          variant="outlined"
          size="medium"
          onClick={handleOpen}
          disabled={isActivityListEmpty || !!chosenVersionId}
          aria-label="Open manage flights drawer"
          data-dd-action-name="Planning header: open manage flights"
        >
          <Calendar />
          {t('Manage flights')}
        </Button>
      </DrawerTrigger>
      <DrawerPortal>
        <DrawerOverlay />
        <DrawerRoot
          onOpenAutoFocus={(e) => e.preventDefault()}
          onInteractOutside={handleClose}
          className="w-[750px]"
        >
          <DrawerHeader onClose={handleClose}>
            <DrawerTitle className="ml-2">{t('Manage Flights')}</DrawerTitle>
          </DrawerHeader>
          <DrawerContent className="flex flex-col" aria-describedby={undefined}>
            <FlightsDrawerContent onClose={handleClose} />
          </DrawerContent>
        </DrawerRoot>
      </DrawerPortal>
    </Drawer>
  );
};

export default ManageFlightsBtn;
